






























import { computed, defineComponent } from "@vue/composition-api";
import { User } from "@scrile/api-provider/dist/api/UserProvider";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import useAuthUser from "@/hooks/useAuthUser";
import { MediaFilesController } from "@/lib/MediaFilesController";
import config from "@/config";
import SubscriberIcon from "@/views/PageMessageThreads/components/SubscriberIcon.vue";
import AvatarBorderAnimation from "./components/AvatarBorderAnimation";

export default defineComponent({
  name: "BaseAvatar",
  components: { AvatarBorderAnimation, SubscriberIcon },
  props: {
    size: { type: [Number, String], default: 112 },
    user: { type: Object as () => UserPublicData | User | null },
    hideOnlineStatus: { type: Boolean, default: false },
    hideBroadcasting: { type: Boolean, default: false },
    animate: { type: Boolean, default: false },
    showBlockStatus: { type: Boolean, default: false },
    subscriberCost: { type: Number },
  },
  setup(props) {
    const { authUser } = useAuthUser();

    const src = computed(
      () =>
        (props.user && props.user.avatar && MediaFilesController.getImageThumbnail(props.user.avatar.urlPart, 224)) ||
        ""
    );
    const isAuthor = computed(() => authUser.value?.id === props.user?.id);
    const invisible = computed(() => props.user?.onlineStatus?.invisible && isAuthor.value);
    const online = computed(
      () =>
        (config.featureUserOnlineStatus &&
          props.user &&
          "onlineStatus" in props.user &&
          props.user.onlineStatus &&
          props.user.onlineStatus.isOnline &&
          !props.user.onlineStatus.invisible &&
          !props.hideOnlineStatus) ||
        false
    );
    const live = computed(
      () =>
        props.user &&
        "publicLivechatUser" in props.user &&
        !!props.user.publicLivechatUser &&
        props.user.onlineStatus &&
        !props.hideBroadcasting &&
        !props.user.onlineStatus.invisible
    );
    const sizeDimension = computed(() => (typeof props.size === "string" ? props.size : `${props.size}px`));
    const sizeNumber = computed(() => parseInt(sizeDimension.value));
    const liveBorderWidth = computed(() => (sizeNumber.value > 100 ? 4 : sizeNumber.value > 50 ? 3 : 2));
    return {
      src,
      online,
      live,
      sizeDimension,
      sizeNumber,
      liveBorderWidth,
      invisible,
    };
  },
});
